import classNames from 'classnames';
import React      from 'react';

const DaysGrid = ({
  currentDate,
  selectedDate,
  getDaysInMonth,
  getFirstDayOfMonth,
  handleDateSelect,
}) => {
  const [today] = React.useState(() => {
    const date = new Date();

    date.setHours(0, 0, 0, 0);

    return date;
  });

  /** @type {number} */
  const currentMonth  = React.useMemo(() => {
    return currentDate.getMonth();
  }, [currentDate]);
  /** @type {number} */
  const nextMonth     = React.useMemo(() => {
    if (currentMonth === 11) {
      return 0;
    }

    return currentMonth + 1;
  }, [currentMonth]);
  /** @type {number} */
  const previousMonth = React.useMemo(() => {
    if (currentMonth === 0) {
      return 11;
    }

    return currentMonth - 1;
  }, [currentMonth]);
  /** @type {number} */
  const currentYear   = React.useMemo(() => {
    return currentDate.getFullYear();
  }, [currentDate]);
  /** @type {number} */
  const daysInMonth   = React.useMemo(() => {
    return getDaysInMonth(currentDate);
  }, [currentDate, getDaysInMonth]);
  /** @type {number} */
  const firstDay      = React.useMemo(() => {
    return (getFirstDayOfMonth(currentDate) + 6) % 7;
  }, [currentDate, getFirstDayOfMonth]);
  const dates         = React.useMemo(() => {
    const firstDay      = (getFirstDayOfMonth(currentDate) + 6) % 7;
    const previousYear  = currentMonth > previousMonth ? currentYear : currentYear - 1;
    const prevMonthDays = getDaysInMonth(new Date(previousYear, previousMonth, 1));
    const nextYear      = currentMonth < nextMonth ? currentYear : currentYear + 1;

    /**
     * @type {{
     *   day: number;
     *   month: number;
     *   year: number;
     * }[]}
     */
    const items = [];

    for (let i = firstDay - 1; i >= 0; i--) {
      items.push({
        day:   prevMonthDays - i,
        month: previousMonth,
        year:  previousYear,
      });
    }

    for (let i = 1; i <= daysInMonth; i++) {
      items.push({
        day:   i,
        month: currentMonth,
        year:  currentYear,
      });
    }

    for (let i = 1; i <= 7 - ((firstDay + daysInMonth) % 7); i++) {
      items.push({
        day:   i,
        month: nextMonth,
        year:  nextYear,
      });
    }

    return items;
  }, [
    currentDate,
    currentMonth,
    currentYear,
    daysInMonth,
    firstDay,
    getDaysInMonth,
    getFirstDayOfMonth,
    nextMonth,
    previousMonth,
  ]);

  return (
    <div className={'days'}>
      {dates.map(({
        day,
        month,
        year,
      }) => {
        const date = new Date(year, month, day);

        return (
          <div
            className={classNames('day', {
              'disabled':   date < today,
              'next_month': month > currentMonth && year === currentYear || year > currentYear,
              'prev_month': month < currentMonth && year === currentYear || year < currentYear,
            })}
            key={date.getTime()}
            onClick={() => {
              if (date >= today) {
                handleDateSelect(day, month);
              }
            }}
          >
            <div className={classNames({ 'active': selectedDate.toDateString() === date.toDateString() })}>
              {day}
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default DaysGrid;